// English source strings of the project's dependency setup (decision D37.2): the Dependencies card, the readiness cause
// codes and the assistant's settings field. Merged into `en`; pt-BR lives in pt-BR-dependencies.ts (complete, checked
// by the type).
export const enDependencies = {
  "deps.title": "Dependencies",
  "deps.body":
    "Before tests and builds, the sandbox installs the project's dependencies with this command. It reaches only the package registries (npm, Yarn) through an allowlist proxy; tests and builds keep running without network. It runs again only when a lockfile or package.json changes.",
  "deps.workspace": "Install command — {path}",
  "deps.hint": "Set by a person only. Agents and the assistant may suggest it; nothing runs until you save.",
  "deps.suggested": "Detected {lockfile}: {command}",
  "deps.useSuggestion": "Use this",
  "deps.noLockfile": "No lockfile found in the checkout the worker reported.",
  "deps.unknownFacts": "The worker has not reported this checkout yet: validate the project to refresh.",
  "deps.allowScripts": "Run the packages' install scripts",
  "deps.allowScriptsHint": "Off by default: install scripts are untrusted code. Turn on only if the project cannot build without them.",
  "deps.registryOk": "Package registries reachable through the sandbox proxy",
  "deps.registryOff": "Dependency installs are not verified on the worker's sandbox yet",
  "deps.cached": "Package managers in the sandbox image: {list}",
  "deps.cachedNone": "The sandbox image has no pnpm or Yarn (build deploy/sandbox-runner)",
  "deps.asks": "The repository asks for {pm}",
  "deps.lastInstalled": "Last install succeeded {when}",
  "deps.lastFailed": "Last install failed {when}: {cause}",
  "deps.saved": "Dependency settings saved. Validate the project to refresh the readiness checks.",
  "deps.readOnly": "Only project maintainers can change the dependency install command.",
  "deps.cause.prepare_not_configured": "Dependencies are never installed: the workspace has no install command",
  "deps.cause.prepare_failed": "The dependency install failed",
  "deps.cause.package_manager_missing": "The package manager is missing from the sandbox image",
  "deps.cause.registry_unreachable": "The package registries could not be reached",
  "deps.cause.package_manager_fallback": "Another version of the package manager is used",
  "assistant.field.prepare_command": "the dependency install command",
} as const;
